import React from "react";
import { useDispatch } from "react-redux";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import { patchClaim } from "../actions";
import Box from "./Box";
import Header from "./Header";

import OCR_IMAGE from "../../../../assets/images/valve-sticker-OCR.jpeg";
import DATAMATRIX_IMAGE from "../../../../assets/images/valve-sticker-datamatrix.jpeg";

export default function ValveStickerChoice() {
  const dispatch = useDispatch();

  const choose = (valve_sticker_variant) => {
    dispatch(patchClaim({ valve_sticker_variant }));
  };

  const goBack = () => {
    dispatch(patchClaim({ step: "validate_label" }));
  };

  return (
    <Box>
      <Header name="Label type" />
      <p className="text-muted small mb-3">
        Choose the picture of the valve that match the one you will be scanning.
      </p>
      <Row className="g-3">
        <Col xs="12" md="6">
          <Card
            className="h-100 border-primary"
            onClick={() => choose("ocr")}
            style={{ cursor: "pointer" }}
          >
            <CardBody className="p-2">
              <img
                src={OCR_IMAGE}
                alt="Valve with printed text label for OCR"
                className="w-100 rounded mb-2"
                style={{ maxHeight: "12rem", objectFit: "contain" }}
              />
              <div className="fw-semibold text-center">Sticker</div>
            </CardBody>
          </Card>
        </Col>
        <Col xs="12" md="6">
          <Card
            className="h-100 border-secondary"
            onClick={() => choose("datamatrix")}
            style={{ cursor: "pointer" }}
          >
            <CardBody className="p-2">
              <img
                src={DATAMATRIX_IMAGE}
                alt="Valve with datamatrix label"
                className="w-100 rounded mb-2"
                style={{ maxHeight: "12rem", objectFit: "contain" }}
              />
              <div className="fw-semibold text-center">Datamatrix</div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <Button color="secondary" className="w-100" onClick={goBack}>
            Back
          </Button>
        </Col>
      </Row>
    </Box>
  );
}
